 <wiz-group  width="100%" height="100%">

    <wiz-hgroup width="100%" height="100%" style="padding: 5px;">
      <wiz-vgroup width="400px" height="100%" class="container">
         
         
         <wiz-vgroup width="100%" height="450px" class="window" >
            <wiz-ag-grid #agGrid
               width="100%"
               height="100%"
               class="ag-theme-alpine"
               [wizDatasource]="freedataDS"
               [columnDefs]="freedataColumns"
               [suppressRowClickSelection]="false"
               [wizRowSelection]="'single'"
            ></wiz-ag-grid>
            <wiz-hgroup width="100%" class="blackbar"style="padding-left: 5px; padding-right: 5px;">
               <wiz-label [wizLabel]="'$.feature.static.FREEDATA.$'" width="100%" class="smallTitle white"></wiz-label>

               <wiz-icon #btnExport [wizTooltip]="'$.common.export.$'" class="image-white smallMe">download</wiz-icon>
               <wiz-icon #btnImport [wizTooltip]="'$.common.import.$'" class="image-white smallMe" >upload</wiz-icon>
               <wiz-icon #btnDelete [wizTooltip]="'$.common.delete.$'" class="image-white smallMe">delete</wiz-icon>
            </wiz-hgroup>
            
         </wiz-vgroup>

         <!-- question IA -->
         <wiz-vgroup width="100%" height="250px" class="window">
            <wiz-hgroup width="100%" class="blackbar"style="padding-left: 5px; padding-right: 5px;">
               <wiz-label [wizLabel]="'$.ia.question.$'" class="smallTitle white"></wiz-label>
            </wiz-hgroup>

            <wiz-vgroup width="100%" height="100%" style="padding: 5px;" horizontalAlign="end">
               <wiz-text-area
                     #aiQuestion
                     width="100%"
                     height="80px"
                     [wizShowLabel]="false"
                     ></wiz-text-area>
               <wiz-button #btnSave  class="blackButton"
               [wizLabel]="'$.ia.send.$'"
               [wizIcon]="'arrow-right'" [iconPlacement]="'right'" width="100px" (click)="doAct('question')"></wiz-button>

               <div class="small">{{questionResponse}}</div>
            </wiz-vgroup>


            
         </wiz-vgroup>
      </wiz-vgroup>

      <wiz-vgroup width="400px" height="100%" class="container">

         <!-- extraction de CV -->
         <wiz-vgroup width="100%" height="100%" class="window">
            <wiz-hgroup width="100%" class="blackbar" style="padding-left: 5px; padding-right: 5px;">
               <wiz-label [wizLabel]="'$.ia.cv.$'" class="smallTitle white"></wiz-label>
            </wiz-hgroup>

            <wiz-vgroup width="100%" height="100%" style="padding: 5px;" horizontalAlign="end">
               
               <input type="file" class="blackButton" (change)="onFileSelected($event)" />
               <wiz-vgroup width="100%" height="100%" style="padding: 5px; overflow-y: scroll;">
                  <div class="small">{{cvResponse}}</div>
               </wiz-vgroup>
                <wiz-vgroup width="100%" height="100%" style="padding: 5px; overflow-y: scroll;">
                  <div class="small">{{cvVector}}</div>
               </wiz-vgroup>
            </wiz-vgroup>


            
         </wiz-vgroup>
  
      </wiz-vgroup>

      <wiz-vgroup width="500px" height="100%" class="container">
         <!-- génération d'image -->
         <wiz-vgroup width="100%" height="600px" class="window">
            <wiz-hgroup width="100%" class="blackbar"style="padding-left: 5px; padding-right: 5px;">
               <wiz-label [wizLabel]="'$.ia.image.$'" class="smallTitle white"></wiz-label>
            </wiz-hgroup>

            <wiz-vgroup width="100%" height="100%" style="padding: 5px;" horizontalAlign="end">
               <wiz-text-area
                     #aiImage
                     width="100%"
                     height="80px"
                     [wizShowLabel]="false"
                     ></wiz-text-area>
               <wiz-button class="blackButton"
               [wizLabel]="'$.ia.send.$'"
               [wizIcon]="'arrow-right'" [iconPlacement]="'right'" width="100px" (click)="doAct('image')"></wiz-button>
               <wiz-hgroup width="100%" horizontalAlign="center" verticalAlign="center" [visible]="!!imageResponse">  
                  <img width="90%" src="{{imageResponse}}"/> 
               </wiz-hgroup>
              
            </wiz-vgroup>
 
         </wiz-vgroup>

         <wiz-vgroup width="100%" height="100%" class="window" >
            <wiz-ag-grid #agGridResponse
               width="100%"
               height="100%"
               class="ag-theme-alpine"
               [wizDatasource]="responseDS"
               [columnDefs]="responseColumns"
               [suppressRowClickSelection]="false"
               [wizRowSelection]="'single'"
            ></wiz-ag-grid>
            <wiz-hgroup width="100%" class="blackbar"style="padding-left: 5px; padding-right: 5px;">
               <wiz-label [wizLabel]="'$.ia.response.$'" class="smallTitle white" width="100%"></wiz-label>
               <wiz-icon #btnExport [wizTooltip]="'$.common.export.$'" class="image-white smallMe">download</wiz-icon>
               <wiz-icon #btnImport [wizTooltip]="'$.common.import.$'" class="image-white smallMe" >upload</wiz-icon>
               <wiz-icon #btnDelete [wizTooltip]="'$.common.delete.$'" class="image-white smallMe">delete</wiz-icon>
            </wiz-hgroup>
            
         </wiz-vgroup>

      </wiz-vgroup>

      <wiz-vgroup width="300px" height="100%" class="container">

         <wiz-vgroup width="100%" height="100%" class="window">
            
            <div style="position: relative; width: 300px; height: 500px;">
					<img src="assets/logo/grassHopper3.0.png" width="300px" style="z-index: 10; position: absolute;"/>
					<div style="vertical-align: middle; z-index: 1; position: absolute; bottom: 40; right: 20; display: flex; gap: 3px;">
						<span style="color: #501F5B;" style="padding-right: 5px;">powered by</span> 
						<img src="assets/logo/allkeyme.png" width="20px"/> 
						<img src="assets/logo/wizeoo.png" width="20px"/> 
						<img src="assets/logo/Angular.png" width="20px"/> 
						<img src="assets/logo/Postgresql.png" width="20px"/>
						<img src="assets/logo/gcp.png" width="20px"/> 
						<img src="assets/logo/openai.png" width="20px"/> 
						<img src="assets/logo/java.png" width="20px"/> 
						<img src="assets/logo/spring.svg" width="20px"/>
					</div>
            </div>

         </wiz-vgroup>




      </wiz-vgroup>




    </wiz-hgroup>

 </wiz-group>
 
